import React from "react";
import { X, ChevronLeft, ChevronRight, Menu } from "lucide-react";
import styles from "./BookPage.module.css";

const BookPage = () => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.readerContainer}>
        {/* Top Navigation */}
        <nav className={styles.topNav}>
          <button className={styles.chaptersBtn}>
            <Menu size={16} />
            Show Chapters
          </button>
          <button className={styles.closeBtn}>
            <X size={20} />
          </button>
        </nav>

        {/* Main Content */}
        <main className={styles.mainContent}>
          <h1 className={styles.bookTitle}>The Village</h1>

          <div className={styles.contentScroll}>
            <p className={styles.paragraph}>
              It is a long established fact that a reader will be distracted by
              the readable content of a page when looking at its layout. The
              point of using Lorem Ipsum is that it has a more-or-less normal
              distribution of letters, as opposed to using 'Content here,
              content here', making it look like readable English. Many desktop
              publishing packages and web page editors now use Lorem Ipsum as
              their default model text, and a search for 'lorem ipsum' will
              uncover many web sites still in their infancy. 1996-09-15 04:00:00
              PDT Los Angeles -- A black hood covered his face. He wore a black
              skirt. His head was slumped against a leather strap chained to the
              headboard of the king-size bed in the sparsely furnished living
              room. Kevin Gilbert, 29, was dead. That much his manager could see
              peering in at the front door that morning last May. The Los
              Angeles County coroner's office sees four or five such deaths a
              year -- "autoerotic asphyxiation," caused when people go one small
              step too far in depriving their brains of oxygen while they reach
              orgasm. It was a death without dignity, a random fall through the
              cracks of a secret life. Gilbert was a prodigy musician from San
              Mateo who could play any instrument; colleagues invariably called
              him "the most talented musician I ever met." To the rest of the
              world, though, his only real claim to fame lies in the credits to
              "Tuesday Night Music Club," the 1993 debut album by Sheryl Crow.
              "I saw something in Entertainment magazine that said Kevin
              Gilbert, the piano player on Sheryl Crow's record, had died," said
              songwriter David Baerwald, a member of the Tuesday club of the
              album's name. He paused, sadly shaking his head. "He hated that
              Sheryl Crow record and that's all he's going to be known for. The
              piano player? Roll over, Kevin Gilbert." When Gilbert first
              brought his girlfriend Sheryl to informal Tuesday night
              songwriting sessions with his friends, he played a pivotal role in
              shaping an $85 million megahit. For her, the album brought three
              Grammys, stardom and an industry buzz that makes her forthcoming
              CD one of the most eagerly anticipated releases this fall. But for
              him, it was hardly a triumph. "I don't know if I can ever forgive
              her," he wrote in his journal. "I don't hate her -- I'm just soooo
              disappointed." In a way it's a classic Hollywood tale: Gifted boy
              artist meets girl artist, mentors her to success and is left in
              the dust -- equal parts "Sunset Boulevard," "A Star Is Born" and
              "All About Eve." By any measure, Gilbert's career was a fitful
              tumble of brilliance and happenstance, a series of near misses and
              one hit that wasn't his. And his Tuesday night cohorts describe
              Crow -- who refused to be interviewed for this story -- as a
              marginally talented singer who exploited his skills and theirs in
              a ruthless grab for success. Advertisement Article continues below
              this ad But this wasn't a movie, and so the real story is
              inevitably messier and more complex. As the circumstances of his
              death suggest, Gilbert had a dark side, a hidden face making him
              an enigma to his friends. There was a history of antidepressants,
              a string of journal entries registering acute self-loathing and
              doubt. Once, he wrote about feeling intimidated when meeting a
              well-known session musician at a concert. "I suck," he wrote,
              circling the words for emphasis. He had a promising start. As a
              South Bay teenager, Gilbert was given the run of Sunnyvale's Sensa
              Sound studio after hours; there, he recorded tracks with his
              progressive rock group, Giraffe. In 1988 he won the U.S. and
              worldwide finals of a talent contest run by the Yamaha piano
              company. One of the judges -- Pat Leonard, a producer for Madonna
              -- invited Gilbert to make a record in Los Angeles. That album,
              "Toy Matinee," sold nearly 200,000 copies in 1991, thanks in part
              to an MTV video featuring actress Rosanna Arquette (whom Gilbert
              had dated). Gilbert put together a road version that included his
              then current girlfriend on background vocals and second keyboard
              -- Sheryl Crow. Making that album, Gilbert, at 21, met another
              record producer, Bill Bottrell, who became a kind of father
              figure. Bottrell brought him to sessions for Madonna and Michael
              Jackson; before long, Gilbert had sublet the space adjacent to
              Bottrell's Pasadena studio, Toad Hall. From there he set about
              recording his solo debut. Drawing on all his perfectionist
              instincts, along with his ingrained self-doubts, Gilbert didn't
              just work on his record; he suffered over it, recording and
              rerecording, polishing, tweaking, rethinking, redoing. "It was a
              long process," said Bottrell, who used to hear Gilbert thumping
              away through the common wall. "He sat over there endless nights."
              In August 1992, Bottrell convened Gilbert and other musicians at
              Toad Hall with the simple agenda of collaborating for the fun of
              it every Tuesday night. "We were all good, not to be immodest,"
              Baerwald said. "We were also all cynical, embittered by the
              process of pop music. We were trying to find some joy in music
              again." A party atmosphere predominated -- "Bill would sift
              through (the music) the next morning while we were all nursing
              hangovers," drummer Brian MacLeod recalled. Then Bottrell
              introduced a project he thought might force a little focus onto
              the freewheeling, chaotic sessions. Crow had finished an album for
              A&M Records, but despite the $500,000 spent on it, nobody at the
              label was thrilled with the results. Hoping for a quick fix, A&M
              hired Gilbert to remix the album, which was, in the immutable
              illogic of the record industry, already scheduled for release.
              Crow's manager asked Bottrell to step in as well. On Crow's first
              Tuesday night with the club, Baerwald showed up with musical
              sidekick David Ricketts (from the 1986 David and David album),
              both of them high on LSD, with the first verse already written to
              a song, "Leaving Las Vegas." Baerwald picked up a guitar, Ricketts
              the bass, and the band fell together to pick up where it had left
              off. Baerwald "couldn't function," said Bottrell. "Sheryl started
              to get drunk. I was looking for that moment when the good take
              would happen." For most of that year, Bottrell and his Tuesday
              crew -- now working all week long -- scrupulously fashioned and
              reshaped Crow's album. Because everything was a collaboration,
              songwriting credits were equally shared. "Everybody was equal,"
              said Baerwald, "except Sheryl. She wasn't one of us. We helped her
              make a record." Gilbert's name wound up on seven of the 11 songs;
              he sang and played keyboards, guitar, bass and drums. His
              relationship with Crow was kept separate and even a secret from
              the group. "I'd see long conversations in the parking lot,"
              Baerwald said. "Kevin challenged her," MacLeod said. "He was
              trying to get her to be honest and sing from her heart." Unsure of
              herself, professionally in over her head, Crow went home with
              Gilbert after sessions and listened to him rant about the
              industry's failings. "She had Kevin filling her with doubts,"
              Bottrell said.
            </p>

            <p className={styles.paragraph}>
              It is a long established fact that a reader will be distracted by
              the readable content of a page when looking at its layout. The
              point of using Lorem Ipsum is that it has a more-or-less normal
              distribution of letters, as opposed to using 'Content here,
              content here', making it look like readable English. Many desktop
              publishing packages and web page editors now use Lorem Ipsum as
              their default model text, and a search for 'lorem ipsum' will
              uncover many web sites still in their infancy.
            </p>

            <p className={styles.paragraph}>
              It is a long established fact that a reader will be distracted by
              the readable content of a page when looking at its layout. The
              point of using Lorem Ipsum is that it has a more-or-less normal
              distribution of letters.
            </p>

            {/* Add more paragraphs to ensure scrolling */}
            {[...Array(5)].map((_, i) => (
              <p key={i} className={styles.paragraph}>
                It is a long established fact that a reader will be distracted
                by the readable content of a page when looking at its layout.
                The point of using Lorem Ipsum is that it has a more-or-less
                normal distribution of letters.
              </p>
            ))}
          </div>

          {/* Page Navigation */}
          <div className={styles.pageNavigation}>
            <button className={styles.navButton} aria-label="Previous page">
              <ChevronLeft size={24} />
            </button>
            <span className={styles.pageNumber}>01</span>
            <button className={styles.navButton} aria-label="Next page">
              <ChevronRight size={24} />
            </button>
          </div>
        </main>
      </div>
    </div>
  );
};

export default BookPage;
